module.exports = __webpack_public_path__ + "static/media/remote-access-control.781016e7.png";